// userSlice.js (or authSlice.js)
import { createAsyncThunk  } from '@reduxjs/toolkit';
import axios from 'axios';
const baseUrl = process.env.REACT_APP_BACKEND_BASE_URL || 'http://localhost:5000';
// Thunk for updating profile
export const updateUserProfile = createAsyncThunk(
  'user/updateProfile',
  async ({ userId, formData, token }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${baseUrl}/users/update/${userId}`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${token}`,
          },
        }
      );
      return response.data; // You can return updated user data
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || 'Failed to update profile.'
      );
    }
  }
);
